import { initSentry, Sentry } from "@/sentry";
initSentry(); // prima di tutto il resto

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Si è verificato un errore. Ricarica la pagina.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
